module.exports = __webpack_public_path__ + "static/media/Teatro.8c0ac374.jpg";